import { render } from "./GroupAdminDashboard.vue?vue&type=template&id=6a12b159&scoped=true"
import script from "./GroupAdminDashboard.vue?vue&type=script&lang=js"
export * from "./GroupAdminDashboard.vue?vue&type=script&lang=js"

import "./GroupAdminDashboard.vue?vue&type=style&index=0&id=6a12b159&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a12b159"]])

export default __exports__